module.exports = __webpack_public_path__ + "static/img/logotwo2.f20f938c.svg";